"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../../helpers/parse");
var parse_2 = require("../../helpers/parse");
var store_1 = require("../store");
var Defaults = /** @class */ (function () {
    function Defaults(config) {
        this.config = config;
    }
    Defaults.prototype.getDefaults = function () {
        var defaults = {};
        var storage = new store_1.default().get();
        // assign values from interactive stage
        if (storage) {
            var assignments = this.config.configJson.localStorage || {};
            assignments = assignments.read || {};
            for (var _i = 0, _a = Object.entries(assignments); _i < _a.length; _i++) {
                var _b = _a[_i], groupName = _b[0], group = _b[1];
                defaults[groupName] = defaults[groupName] || {};
                for (var _c = 0, _d = Object.entries(group); _c < _d.length; _c++) {
                    var _e = _d[_c], property = _e[0], value = _e[1];
                    defaults[groupName][property] = parse_2.interpolate(value, storage);
                }
            }
        }
        function assignValue(option, groupName, id) {
            defaults[groupName] = defaults[groupName] || {};
            var isUndefined = defaults[groupName][id] === undefined;
            // Options with nested properties
            if (option.hasOwnProperty('property')) {
                defaults[groupName][id] = defaults[groupName][id] || {};
                var isActive = !!(option.condition);
                var property = option.property;
                var propUndefined = defaults[groupName][id][property] === undefined;
                if (isActive && propUndefined) {
                    defaults[groupName][id][property] = option.value;
                    return true;
                }
                // Regular options
            }
            else if (!Array.isArray(option)) {
                var isActive = !!(option.condition);
                if (isActive && isUndefined) {
                    defaults[groupName][id] = option.value;
                    return true;
                }
                // empty arrays:
            }
            else if (!option.length) {
                defaults[groupName][id] = option;
                return true;
                // Checkboxes
            }
            else {
                var activeOption = option.find(function (opt) { return !!(opt.condition); });
                if (activeOption && isUndefined) {
                    defaults[groupName][id] = activeOption.value;
                    return true;
                }
            }
            return false;
        }
        for (var i = 0; i < Defaults.MAX_ITERATIONS; i++) {
            var resolved = false;
            var forms = Object.assign({}, this.config.forms);
            this.config.eachFormOption(function (option, groupName, id) {
                parse_1.evaluateOptions(option, defaults);
            });
            for (var _f = 0, _g = Object.entries(forms); _f < _g.length; _f++) {
                var _h = _g[_f], groupName = _h[0], group = _h[1];
                for (var _j = 0, _k = Object.entries(group); _j < _k.length; _j++) {
                    var _l = _k[_j], id = _l[0], form = _l[1];
                    if (!form.options.length && assignValue(form.options, groupName, id)) {
                        resolved = true;
                    }
                    var options = [];
                    for (var _m = 0, _o = Object.values(form.options); _m < _o.length; _m++) {
                        var option = _o[_m];
                        if (option.condition === true) {
                            options.push(option);
                        }
                    }
                    if (options.length) {
                        if (options[0].hasOwnProperty('property')) {
                            for (var _p = 0, options_1 = options; _p < options_1.length; _p++) {
                                var option = options_1[_p];
                                if (assignValue(option, groupName, id)) {
                                    resolved = true;
                                }
                            }
                        }
                        else {
                            var dflt = !form.hasOwnProperty('default') || form.default >= options.length ?
                                0 : form.default;
                            if (assignValue(options[dflt], groupName, id)) {
                                resolved = true;
                            }
                        }
                    }
                }
            }
            if (!resolved) {
                break;
            }
            if (i >= Defaults.MAX_ITERATIONS) {
                console.warn('Error resolving defaults. Reached maximum level of iterations.');
            }
        }
        return defaults;
    };
    Defaults.MAX_ITERATIONS = 25;
    return Defaults;
}());
exports.default = Defaults;
